import { confirmationOfRecord, errorActions } from "@/alerts";
import axios from "../../../api";
/**
 * Funcion para insertar una venta
 * @param {*} saleID Identificador de la venta
 * @returns El id de la venta registrada
 */
export const trySendInvoice = async (saleID) => {
  try {
    const response = await axios.post(
      "reenviar-comprobante",
      {
        sale_id: saleID,
      },
      {
        method: {
          "Content-Type": "application/json",
        },
      }
    );
    const data = await response.data;
    if (data.msg === true) {

      if (!data.signedInvoice.code && !data.signedInvoice.url) {
        errorActions(`Ocurrio un error al reenviar el comprobante`);
        return;
      }

      confirmationOfRecord(`El comprobante se volvio a envia`);
      return data.id;
    } else {
      errorActions(
        `Lo sentimos no pudimos reenviar el comprobante de la venta, vuelve a intentarlo mas tarde.`
      );
    }
  } catch (error) {
    errorActions(error);
  }
};
